import React from 'react';
import { Icon, PanelHeader } from 'js/components';
import { Breadcrumbs } from 'js/components/Breadcrumbs';
import {
  faCalendarAlt,
  faClipboardListCheck,
} from '@fortawesome/pro-regular-svg-icons';
import { formatSnapshotAsOf } from './org-snapshot-utils';
import styles from './OrgSnapshots.module.scss';

export function orgPageTitle(organization, workspace) {
  if (!organization) {
    return 'Organization';
  }
  if (organization.id === 0) {
    return workspace?.name || 'All teams';
  }
  return organization.name;
}

export default function OrgSnapshotChrome({
  workspaceId,
  orgId,
  organization,
  workspace,
  sourceKey = null,
  sourceName = null,
  snapshotName = null,
  snapshotAt = null,
  extra = null,
  children = null,
}) {
  const orgLabel = orgPageTitle(organization, workspace);
  const orgTo = sourceKey
    ? `/w/${workspaceId}/orgs/${orgId}/${encodeURIComponent(sourceKey)}`
    : `/w/${workspaceId}/orgs/${orgId}`;
  const title =
    snapshotName ||
    extra?.title ||
    sourceName ||
    extra?.fallbackTitle ||
    orgLabel;
  const breadcrumbs = [
    { label: 'Organizations', to: `/w/${workspaceId}/orgs/` },
    { label: orgLabel, to: orgTo },
  ];
  if (extra?.currentCrumb) {
    breadcrumbs.push(extra.currentCrumb);
  }
  const asOf = formatSnapshotAsOf(snapshotAt);

  return (
    <div>
      <PanelHeader size="flex">
        <div
          className={
            extra?.hideTitle
              ? 'panel-body-no-label px-4'
              : 'panel-content assessment-review-header pb-0'
          }
        >
          <div className={extra?.hideTitle ? undefined : 'container-fluid'}>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            {extra?.hideTitle ? null : (
              <section className="details flex">
                <div className={`details-main ${styles.headerMain}`}>
                  <h1>{title || '\u00a0'}</h1>
                  {asOf || sourceName ? (
                    <div className={styles.metaRow}>
                      {asOf ? (
                        <div className={styles.metaItem}>
                          <Icon
                            icon={faCalendarAlt}
                            className="icon-left text-info"
                          />
                          <span className={styles.metaText}>{asOf}</span>
                        </div>
                      ) : null}
                      {sourceName ? (
                        <div className={styles.metaItem}>
                          <Icon
                            icon={faClipboardListCheck}
                            className="icon-left text-info"
                          />
                          <span className={styles.metaText}>{sourceName}</span>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                {extra?.header || extra?.actions ? (
                  <div className="details-sidebar">
                    {extra.header}
                    {extra.actions ? (
                      <div className="panel-actions">{extra.actions}</div>
                    ) : null}
                  </div>
                ) : null}
              </section>
            )}
          </div>
        </div>
        {extra?.chart ? (
          <div
            className="container-fluid org-chart-selector"
            style={{ marginBottom: '2rem' }}
          >
            {extra.chart}
          </div>
        ) : null}
        {extra?.tabs ? (
          <div className="container-fluid">{extra.tabs}</div>
        ) : null}
      </PanelHeader>
      <div className="content">{children}</div>
    </div>
  );
}
